import React from "react";
import "./App.less";
import { Routes } from "./routes";

function App() {
  return <Routes />;
}

export default App;
